import type { IvaQuarterRef } from "../../api/types";
import { monthName } from "./MonthNav";

/**
 * G-171: how a quarter is named on the two IVA cards — one place, so "IVA on
 * sales" and "Balance with Hacienda" name the same quarter the same way.
 */

/** "Q3 2026". */
export function quarterLabel(q: Pick<IvaQuarterRef, "year" | "quarter">): string {
  return `Q${q.quarter} ${q.year}`;
}

/** "July · August · September", or "October · to date" while the quarter runs. */
export function quarterMonthsText(q: IvaQuarterRef): string {
  const names = q.months.map((m) => monthName(q.year, m));
  return q.toDate ? [...names, "to date"].join(" · ") : names.join(" · ");
}
